import { Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { Price } from '../../../../types/searchAvailability'
import { compareAtTotal, discountPercent } from './helpers'

type CompareAtPriceProps = {
  price: Price
  className?: string
}

/**
 * The struck-through "compare-at" price (ADR-040 §2.3). Renders nothing unless
 * the anchor is strictly above the price actually charged — absence of an
 * anchor, an equal anchor, and a lower anchor all render nothing.
 */
export const CompareAtPrice: React.FC<CompareAtPriceProps> = ({
  price,
  className
}) => {
  const compareAt = compareAtTotal(price)

  if (compareAt === null) {
    return null
  }

  return (
    <Typography variant="h5" className={className}>
      {` ${addCommaToPrice(compareAt)} ${getTranslate(price.currency || '')}`}
    </Typography>
  )
}

type DiscountBadgeProps = {
  price: Price
  wrapperClassName?: string
  textClassName?: string
}

/**
 * The "N% off" badge. Renders nothing unless there is a genuine discount, so it
 * can never show a zero, negative, NaN or Infinity percentage.
 */
export const DiscountBadge: React.FC<DiscountBadgeProps> = ({
  price,
  wrapperClassName,
  textClassName
}) => {
  const percentOff = discountPercent(price)

  if (percentOff === null) {
    return null
  }

  return (
    <div className={wrapperClassName}>
      <Typography variant="h5" className={textClassName}>
        {`${percentOff}% ${getTranslate('off')}`}
      </Typography>
    </div>
  )
}
